import { graphql } from '@eluve/graphql.tada';

export const updateTenantDetailsMutation = graphql(`
  mutation UpdateTenantDetails(
    $tenantId: uuid!
    $logoUrl: String
    $name: String
  ) {
    updateTenantsByPk(
      pkColumns: { id: $tenantId }
      _set: { logoUrl: $logoUrl, name: $name }
    ) {
      __typename
      id
      logoUrl
      name
    }
  }
`);
